export default (apiFetch) => async (payload) => {
  const response = await apiFetch({
    endpoint: "request-info",
    method: "POST",
    body: payload,
    headers: {},
  });

  return await response.json();
};
